import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { ForecastIconLoadingUI } from '../common/forecastIconLoadingUI';

export const WeatherInfoLoadingUI = () => {
    return (
        <Container>
            <ForecastIconLoadingUI />
            <CardInfoPlaceholder>
                <AnimatedLoadingPlaceholder key='hour-card-hour-animated-loading-ui' width={63} height='20px' />
                <AnimatedLoadingPlaceholder key='hour-card-condition-animated-loading-ui' width={79} height='25px' />
            </CardInfoPlaceholder>
            <ConditionsInfoPlaceholder>
                <AnimatedLoadingPlaceholder key='hour-card-temp-reading-animated-loading-ui' width={43} height='25px' />
                <AnimatedLoadingPlaceholder key='hour-card-precip-info-animated-loading-ui' width={65} height='17px' />
            </ConditionsInfoPlaceholder>
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    flex-direction: row;
    padding: 5px 10px;
    background-color: #f9f9f9;
    border-radius: 2px;
    height: 60px;
    width: 100%;
    margin-bottom: 5px;
`;

const CardInfoPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: calc((100% - 50px) - 68px);
    padding: 0px 6px;
    justify-content: space-between;
`;

const ConditionsInfoPlaceholder = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 68px;
`;